<template>
	<aside class="modal-sidebar">
		<div class="sidebar-content">
			<div class="sidebar-provider-logo">
				<svg><use :xlink:href="`#provider-${provider.slug}`"></use></svg>
			</div><!-- end.sidebar-provider-logo -->
			<div class="sidebar-pre-order-bar" v-if="provider.pre_order">
				<p>You will be placing a pre-order. <br />Your area is still in the rollout phase.</p>
			</div><!-- end.sidebar-pre-order-bar -->

			<div class="sidebar-line-items">
				<div class="line-item">
					<p>Installation</p>
					<dl v-if="provider.meta.installation_fee">
						<dt v-if="provider.meta.installation_fee_override == 0">FREE with Afrihost</dt>
						<dt v-else>R{{ provider.meta.installation_fee_override }} with Afrihost</dt>
						<dd class="strike">R{{ provider.meta.installation_fee }}</dd>

					</dl>
					<dl v-else>
						<dd>Included</dd>
					</dl>
				</div><!-- end.line-item -->
				<div class="line-item">
					<p>Activation Fee</p>
					<dl v-if="provider.meta.activation_fee">
						<dt>FREE with Afrihost</dt>
						<dd class="strike">R{{ provider.meta.activation_fee }}</dd>
					</dl>
					<dl v-else>
						<dd>Included</dd>
					</dl>
				</div><!-- end.line-item -->
				<div class="line-item">
					<p>WiFi Router</p>
					<dl>
						<dt>FREE with Afrihost</dt>
						<dd class="strike">R999.00</dd>
					</dl>
				</div><!-- end.line-item -->
			</div><!-- end.sidebar-line-items -->

<!--			<sidebar-promo-->
<!--				v-if="provider.slug === 'vumatel'"-->
<!--				:solution="solution"-->
<!--				:solutions="solutions">-->
<!--			</sidebar-promo>-->

		</div><!-- end.sidebar-content -->
		<div class="sidebar-footer">
			<div class="icon"><svg><use xlink:href="#map-pin"></use></svg></div>
			<p><formatted-address :place="place"></formatted-address> - <router-link :to="{name: 'coverage'}">Edit Address</router-link></p>
		</div><!-- end.sidebar-footer -->
	</aside><!-- end.modal-sidebar -->
</template>
<script>
	import SidebarPromo from "../components/SidebarPromo"
	import FormattedAddress from '../components/FormattedAddress'

	export default {
		props: ['provider', 'solution', 'solutions'],
		components: {
			SidebarPromo,
			FormattedAddress
		},
		computed: {
			place() {
				return this.$store.getters['coverage/place'];
			},
			assetBase() {
				return window._assetBaseUrl;
			}
		}
	}
</script>

